import React from 'react';
import WidgetControl from '../control';
import { HeaderSection, HeaderTitle, HeaderControls } from '../../MetricPanel/styled';

const Header = () => {
  return (
    <HeaderSection>
      <HeaderTitle>Flows</HeaderTitle>
      <HeaderControls>
        <WidgetControl />
      </HeaderControls>
    </HeaderSection>
  );
};

export default Header;
